import ReconnectingWebSocket from 'reconnecting-websocket';
export function createReconnectingWebSocketInstance(url, name, id) {
  var formattedUrl = url ? url + '/' : '';
  var finalUrl = process.env.VUE_APP_WS_URL + name + '/' + formattedUrl + id + '/';
  return new ReconnectingWebSocket(finalUrl);
}